/** Fired when refresh-token recovery fails and the user must sign in again. */

type SessionExpiredListener = () => void;

const listeners = new Set<SessionExpiredListener>();
let isPending = false;

export function onSessionExpired(listener: SessionExpiredListener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function emitSessionExpired(): void {
  if (isPending) return;
  isPending = true;
  listeners.forEach((listener) => listener());
}

export function resetSessionExpiredState(): void {
  isPending = false;
}
